export default __webpack_public_path__ + "static/media/make_use_all.9952ad17.jpg";